import React from "react";
import { Title } from "../../library";

const titleStyle = {
  padding: "0 14px",
};

export default function SweetsPerGuestCalculatorDescription() {
  return (
    <Title as="h4" style={titleStyle} strong>
      Esses números são apenas indicações. Cada evento é único e o comportamento
      do convidado pode mudar para mais ou para menos.
    </Title>
  );
}
